import React, { useState } from "react";
import { FaFingerprint } from "react-icons/fa";
import { Accordion } from "react-bootstrap";
import { FaAngleUp } from "react-icons/fa";
import ButtonList from "../ButtonList/ButtonList";
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { IoClose } from "react-icons/io5";
import SupportPopup from "../SupportPopup/SupportPopup";
import { Link } from "react-router-dom";
import RemoateFitting from "../RemoateFitting/RemoateFitting";


function FittingRates() {

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>

            <Modal
                show={show}
                onHide={handleClose}
                centered
                id="success_tic"
                className="center-form-modal"
            >
                <Modal.Body>
                    <div className="custom-modal-header">
                        <h3 className="text mb-5">How can we help?</h3>
                        <div className="close-modal">
                            <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"> <IoClose /></button>
                        </div>
                    </div>
                    <SupportPopup />
                </Modal.Body>
            </Modal>


            <section id="fitting_rate" className="fitting_rate bg_dark page-section pb-0">
                <div className="container-xl separate-container">
                    <div className="d-flex align-items-center justify-content-between sec_tile_bar">
                        <h2 className="sec_title">Find a fitter</h2>
                        <div className="btn-section hide_mobile">
                            <ButtonList subject="club fitting" />
                        </div>
                    </div>
                    {/* desktop or tablet view */}
                    <div className="row hide_mobile_f">
                        <div className="col-lg-12 w_1280">
                            {/* Rate 1 */}
                            <div className="gs_b gs_fr gs_fr_full rate_card_mobile">
                                <div className="row d-flex align-items-center justify-content-between">
                                    <div className="gab_title col-lg-4">
                                        <div className="gab_icon">
                                            <img src={`forewardFindFitterIcon.svg`} alt="" />
                                        </div>
                                        <div className="gab_text">
                                            <h5>Foreward Fitters</h5>
                                            <small>Certified Personel </small>
                                        </div>
                                    </div>
                                    <div className="gs_fr_text col-lg-4">
                                        <p>
                                            Receive a Foreward Fitting by a trained
                                            professional near you.
                                        </p>
                                        <a className="link-icon" href="#"> The same process we perform</a>
                                        {/* <a className="link-icon" href="#"> <i className="bi bi-youtube" /> Watch Video</a> */}
                                    </div>
                                    <div className="col-lg-4">
                                        <a href="/fitter/fitter-locator" target="_blank" className="btn btn_default bg-white text-dark gs_fr_action newfix">Find your fitter <strong>Click Here</strong></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="show_mobile">
                        <Accordion defaultActiveKey="3">
                            <div className="row">
                            <div className="col-lg-12">
                                <Accordion.Item eventKey="3" className="mobile-accordion">
                                    <div className="gs_b gs_fr rate_card_mobile accordion-item">
                                        <div className="gs_fr_top" id="lesson_card_1">
                                            <Accordion.Header>
                                                <div className="gab_title">
                                                    <div className="gab_text">
                                                        <h5>Foreward Fitters</h5>
                                                        <small>Certified Personel </small>
                                                    </div>
                                                    <div className="collapsed">
                                                        <div className="gab_icon ">
                                                            <FaAngleUp />
                                                        </div>
                                                    </div>
                                                </div>
                                            </Accordion.Header>
                                        </div>
                                        <Accordion.Body>
                                            <div className="gs_fr_text">
                                                <p>
                                                    Receive a Foreward Fitting by a trained
                                                    professional near you.
                                                </p>
                                                <a className="link-icon" href="#"> The same process we perform</a>
                                            </div>
                                            <a href="/fitter/fitter-locator" target="_blank" className="btn btn_default bg-white text-dark gs_fr_action newfix">Find your fitter <strong>Click Here</strong></a>
                                        </Accordion.Body>
                                    </div>
                                </Accordion.Item>
                            </div>
                            </div>
                        </Accordion>
                    </div>
                </div>
            </section>

            <section id="fitting_rate" className="fitting_rate bg_dark page-section">
                <div className="container-xl separate-container">
                    <div className="d-flex align-items-center justify-content-between sec_tile_bar">
                        <h2 className="sec_title">Visit our studio</h2>
                        <div className="btn-section hide_mobile">
                            <ButtonList subject="club fitting" />
                        </div>
                    </div>
                    {/* desktop or tablet view */}
                    <div className="row hide_mobile_f">
                        <div className="col-lg-4 w_1280 w_5872">
                            <div className="gs_b gs_fr">
                                <div className="gs_fr_top">
                                    <div className="gab_title">
                                        <div className="gab_icon">
                                            <img src={require('../../assets/images/forewardLandingClubs.png')} alt="" />
                                        </div>
                                        <div className="gab_text text-left">
                                            <h5>Complete Bag</h5>
                                            <small>Club Fitting </small>
                                        </div>
                                    </div>
                                    <div className="gs_fr_text">
                                        <p>
                                            Four sessions to get your bag fit and built to your specs.
                                        </p>
                                        <a className="link-icon" href="#"> Four 1.5 hour fitting sessions</a>
                                        {/* <a className="link-icon" href="#"> <i className="bi bi-youtube" /> Watch Video</a> */}
                                    </div>

                                    <a style={{ display: "none" }} href="https://squareup.com/appointments/book/04e7x17cqe2t5b/LPA9B43QT768F/start" target="_blank" className="btn btn_default bg-white text-dark gs_fr_action hide_1280 hide_tab complate_bag_btn">
                                        Book now for <strong>$499</strong>
                                    </a>
                                </div>
                                <div id="outer" className="marquee-5872">
                                    <ul id="tick" className="gs_fr_list">
                                        <li className><i className="bi bi-check" /> Save 25%</li>
                                        <li className><i className="bi bi-check" /> Driver + Woods</li>
                                        <li className><i className="bi bi-check" /> Irons + Hybrids</li>
                                        <li className><i className="bi bi-check" /> Wedges</li>
                                        <li className><i className="bi bi-check" /> Putter</li>
                                    </ul>
                                </div>
                                <div className="marquee-wrapper slider-5872">
                                    <div className>
                                        <div className="marquee-block marquee-block11">
                                            <div className="marquee-inner to-left">
                                                <span>
                                                    <div className="marquee-item">
                                                        <p className="gs_fr_list"><i className="bi bi-check" />Save 25%</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Driver + Woods</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Irons + Hybrids</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" /> Wedges</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Putter</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="gs_fr_list"><i className="bi bi-check" />Save 25%</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Driver + Woods</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Irons + Hybrids</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" /> Wedges</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Putter</p>
                                                    </div>
                                                </span>
                                                <span>
                                                    <div className="marquee-item">
                                                        <p className="gs_fr_list"><i className="bi bi-check" />Save 25%</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Driver + Woods</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Irons + Hybrids</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" /> Wedges</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Putter</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="gs_fr_list"><i className="bi bi-check" />Save 25%</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Driver + Woods</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Irons + Hybrids</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" /> Wedges</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Putter</p>
                                                    </div>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <a href="https://squareup.com/appointments/book/04e7x17cqe2t5b/LPA9B43QT768F/start" target="_blank" className="btn btn_default bg-white text-dark gs_fr_action hide_1280 hide_tab">
                                    Book now for <strong>$499</strong>
                                </a>

                            </div>
                        </div>
                        <div className="col-lg-8 w_1280">
                            {/* Rate 1 */}
                            <div className="gs_b gs_fr gs_fr_full">
                                <div className="row d-flex align-items-center justify-content-between">
                                    <div className="gab_title col-lg-4">
                                        <div className="gab_icon">
                                            <img src={require('../../assets/images/DriverClubSelections.png')} alt="" />
                                        </div>
                                        <div className="gab_text">
                                            <h5>Driver + Woods</h5>
                                            <small>Club Fitting </small>
                                        </div>
                                    </div>
                                    <div className="gs_fr_text col-lg-4">
                                        <p>
                                            Get your driver and woods fit and built to your specs.
                                        </p>
                                        <a className="link-icon" href="#"> One 1.5 hour fitting session</a>
                                        {/* <a className="link-icon" href="#"> <i className="bi bi-youtube" /> Watch Video</a> */}
                                    </div>
                                    <div className="col-lg-4">
                                        <a href="https://squareup.com/appointments/buyer/widget/qv2fqmjlvm78yr/LPA9B43QT768F" target="_blank" className="btn btn_default bg-white text-dark gs_fr_action">Book now for <strong>$199</strong></a>
                                    </div>
                                </div>
                            </div>
                            {/* Rate 2 */}
                            <div className="gs_b gs_fr gs_fr_full">
                                <div className="row d-flex align-items-center justify-content-between">
                                    <div className="gab_title col-lg-4">
                                        <div className="gab_icon">
                                            <img src={require('../../assets/images/7IronClubSelections.png')} alt="" />
                                        </div>
                                        <div className="gab_text">
                                            <h5>Irons + Hybrids</h5>
                                            <small>Club Fitting </small>
                                        </div>
                                    </div>
                                    <div className="gs_fr_text col-lg-4">
                                        <p>
                                            Get your irons and hybrids fit and built to your specs.
                                        </p>
                                        <a className="link-icon" href="#"> One 1.5 hour fitting session</a>
                                        {/* <a className="link-icon" href="#"> <i className="bi bi-youtube" /> Watch Video</a> */}
                                    </div>
                                    <div className="col-lg-4">
                                        <a href="https://squareup.com/appointments/buyer/widget/j57hiynj5uucjx/LPA9B43QT768F" target="_blank" className="btn btn_default bg-white text-dark gs_fr_action">Book now for <strong>$199</strong></a>
                                    </div>
                                </div>
                            </div>
                            {/* Rate 3 */}
                            <div className="gs_b gs_fr gs_fr_full">
                                <div className="row d-flex align-items-center justify-content-between">
                                    <div className="gab_title col-lg-4">
                                        <div className="gab_icon">
                                            <img src={require('../../assets/images/GabWedgeClubSelections.png')} alt="" />
                                        </div>
                                        <div className="gab_text">
                                            <h5>Wedges</h5>
                                            <small>Club Fitting </small>
                                        </div>
                                    </div>
                                    <div className="gs_fr_text col-lg-4">
                                        <p>
                                            Get the wedges in your bag fit and built to your specs.
                                        </p>
                                        <a className="link-icon" href="#"> One 1.5 hour fitting session</a>
                                        {/* <a className="link-icon" href="#"> <i className="bi bi-youtube" /> Watch Video</a> */}
                                    </div>
                                    <div className="col-lg-4">
                                        <a href="https://squareup.com/appointments/buyer/widget/irjd9e8xh35etq/LPA9B43QT768F" target="_blank" className="btn btn_default bg-white text-dark gs_fr_action">Book now for <strong>$199</strong></a>
                                    </div>
                                </div>
                            </div>
                            {/* Rate 4 */}
                            <div className="gs_b gs_fr gs_fr_full">
                                <div className="row d-flex align-items-center justify-content-between">
                                    <div className="gab_title col-lg-4">
                                        <div className="gab_icon">
                                            <img src={require('../../assets/images/Putter.png')} alt="" />
                                        </div>
                                        <div className="gab_text">
                                            <h5>Putter</h5>
                                            <small>Club Fitting </small>
                                        </div>
                                    </div>
                                    <div className="gs_fr_text col-lg-4">
                                        <p>
                                            Get your putter analyzed, fit and built to your specs.
                                        </p>
                                        <a className="link-icon" href="#"> One 1.5 hour fitting session</a>
                                        {/* <a className="link-icon" href="#"> <i className="bi bi-youtube" /> Watch Video</a> */}
                                    </div>
                                    <div className="col-lg-4">
                                        <a href="https://squareup.com/appointments/buyer/widget/s1d6wiohzhipid/LPA9B43QT768F" target="_blank" className="btn btn_default bg-white text-dark gs_fr_action">Book now for <strong>$199</strong></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* desktop or tablet view */}
                    {/* only mobile view view */}
                    <Accordion>
                        <div className="row show_mobile">
                            <div className="col-lg-4">
                                <Accordion.Item eventKey="0" className="mobile-accordion">
                                    <div className="gs_b gs_fr rate_card_mobile accordion-item">
                                        <div className="gs_fr_top" id="lesson_card_1">
                                            <Accordion.Header>
                                                <div className="gab_title">
                                                    <div className="gab_text text-left">
                                                        <h5>Complete Bag</h5>
                                                        <small>Club Fitting </small>
                                                    </div>
                                                    <div className="collapsed">
                                                        <div className="gab_icon ">
                                                            <FaAngleUp />
                                                        </div>
                                                    </div>
                                                </div>
                                            </Accordion.Header>
                                        </div>
                                        <Accordion.Body>
                                            <div className="gs_fr_text">
                                                <p>
                                                    Four sessions to get your bag fit and built to your specs.
                                                </p>
                                                <a className="link-icon" href="#"> Four 1.5 hour fitting session</a>
                                            </div>
                                            <ul className="gs_fr_list">
                                                <li className><i className="bi bi-check" /> Save 25%</li>
                                                <li className><i className="bi bi-check" /> Driver + Woods</li>
                                                <li className><i className="bi bi-check" /> Irons + Hybrids</li>
                                                <li className><i className="bi bi-check" /> Wedges</li>
                                                <li className><i className="bi bi-check" /> Putter</li>
                                            </ul>
                                            {/* <a className="" onClick={handleShow}>Complete Bag3 <strong>$499</strong></a> */}

                                            <a href="https://squareup.com/appointments/book/04e7x17cqe2t5b/LPA9B43QT768F/start" target="_blank" className="btn btn_default bg-white text-dark gs_fr_action">
                                                Book now for <strong>$499</strong>
                                            </a>


                                        </Accordion.Body>
                                    </div>
                                </Accordion.Item>
                            </div>
                            <div className="col-lg-4">
                                <Accordion.Item eventKey="1" className="mobile-accordion">
                                    <div className="gs_b gs_fr rate_card_mobile accordion-item">
                                        <div className="gs_fr_top" id="lesson_card_1">
                                            <Accordion.Header>
                                                <div className="gab_title">
                                                    <div className="gab_text">
                                                        <h5>Driver + Woods</h5>
                                                        <small>Club Fitting </small>
                                                    </div>
                                                    <div className="collapsed">
                                                        <div className="gab_icon ">
                                                            <FaAngleUp />
                                                        </div>
                                                    </div>
                                                </div>
                                            </Accordion.Header>
                                        </div>
                                        <Accordion.Body>
                                            <div className="gs_fr_text">
                                                <p>
                                                    Get your driver and woods fit and built to your specs.
                                                </p>
                                                <a className="link-icon" href="#"> One 1.5 hour fitting session</a>
                                            </div>
                                            <a href="https://squareup.com/appointments/buyer/widget/qv2fqmjlvm78yr/LPA9B43QT768F" target="_blank" className="btn btn_default bg-white text-dark gs_fr_action">Book now for <strong>$199</strong></a>
                                        </Accordion.Body>
                                    </div>
                                </Accordion.Item>
                            </div>
                            <div className="col-lg-4">
                                <Accordion.Item eventKey="2" className="mobile-accordion">
                                    <div className="gs_b gs_fr rate_card_mobile accordion-item">
                                        <div className="gs_fr_top" id="lesson_card_1">
                                            <Accordion.Header>
                                                <div className="gab_title">
                                                    <div className="gab_text">
                                                        <h5>Irons + Hybrids</h5>
                                                        <small>Club Fitting </small>
                                                    </div>
                                                    <div className="collapsed">
                                                        <div className="gab_icon ">
                                                            <FaAngleUp />
                                                        </div>
                                                    </div>
                                                </div>
                                            </Accordion.Header>
                                        </div>
                                        <Accordion.Body>
                                            <div className="gs_fr_text">
                                                <p>
                                                    Get your irons and hybrids fit and built to your specs.
                                                </p>
                                                <a className="link-icon" href="#"> One 1.5 hour fitting session</a>
                                            </div>
                                            <a href="https://squareup.com/appointments/buyer/widget/j57hiynj5uucjx/LPA9B43QT768F" target="_blank" className="btn btn_default bg-white text-dark gs_fr_action">Book now for <strong>$199</strong></a>
                                        </Accordion.Body>
                                    </div>
                                </Accordion.Item>
                            </div>
                            <div className="col-lg-4">
                                <Accordion.Item eventKey="3" className="mobile-accordion">
                                    <div className="gs_b gs_fr rate_card_mobile accordion-item">
                                        <div className="gs_fr_top" id="lesson_card_1">
                                            <Accordion.Header>
                                                <div className="gab_title">
                                                    <div className="gab_text">
                                                        <h5>Wedges</h5>
                                                        <small>Club Fitting </small>
                                                    </div>
                                                    <div className="collapsed">
                                                        <div className="gab_icon ">
                                                            <FaAngleUp />
                                                        </div>
                                                    </div>
                                                </div>
                                            </Accordion.Header>
                                        </div>
                                        <Accordion.Body>
                                            <div className="gs_fr_text">
                                                <p>
                                                    Get the wedges in your bag fit and built to your specs.
                                                </p>
                                                <a className="link-icon" href="#"> One 1.5 hour fitting session</a>
                                            </div>
                                            <a href="https://squareup.com/appointments/buyer/widget/irjd9e8xh35etq/LPA9B43QT768F" target="_blank" className="btn btn_default bg-white text-dark gs_fr_action">Book now for <strong>$199</strong></a>
                                        </Accordion.Body>
                                    </div>
                                </Accordion.Item>
                            </div>
                            <div className="col-lg-4">
                                <Accordion.Item eventKey="4" className="mobile-accordion">
                                    <div className="gs_b gs_fr rate_card_mobile accordion-item">
                                        <div className="gs_fr_top" id="lesson_card_1">
                                            <Accordion.Header>
                                                <div className="gab_title">
                                                    <div className="gab_text">
                                                        <h5>Putter</h5>
                                                        <small>Club Fitting </small>
                                                    </div>
                                                    <div className="collapsed">
                                                        <div className="gab_icon ">
                                                            <FaAngleUp />
                                                        </div>
                                                    </div>
                                                </div>
                                            </Accordion.Header>
                                        </div>
                                        <Accordion.Body>
                                            <div className="gs_fr_text">
                                                <p>
                                                    Get your putter analyzed, fit and built to your specs.
                                                </p>
                                                <a className="link-icon" href="#"> One 1.5 hour fitting session</a>
                                            </div>
                                            <a href="https://squareup.com/appointments/buyer/widget/s1d6wiohzhipid/LPA9B43QT768F" target="_blank" className="btn btn_default bg-white text-dark gs_fr_action">Book now for <strong>$199</strong></a>
                                        </Accordion.Body>
                                    </div>
                                </Accordion.Item>
                            </div>
                        </div>
                    </Accordion>
                    {/* only mobile view view */}
                    <div className="btn-section hide_desktop-v2">
                        <ButtonList subject="club fitting" />
                    </div>
                </div>
            </section>

        </>
    );
}

export default FittingRates;